import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'results-modal',
  templateUrl: './results-modal.component.html',
})
export class ResultsModalComponent implements OnInit {
  @Input() results: any;
  @Input() sites: any;

  public cols: any[];
  public rows: any[];

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit() {
    const siteColumns = this.sites.map(site => site.name).sort((a, b) => a.localeCompare(b));

    // data
    this.rows = this.results.map(result => {
      let row = {
        email: result.email,
        createUser: result.createUser ? true : 'User already exists',
      };

      siteColumns.forEach(siteName => {
        const siteResult = result.workerUserSite.find(s => s.siteName === siteName);
        row[siteName] = siteResult.added ? true : 'User already added to site';
      });

      return row;
    });

    // column headings
    this.cols = [
      { field: 'email', header: 'Email' },
      { field: 'createUser', header: 'User created and invite sent', type: 'tick-or-text' },
    ];

    siteColumns.forEach(siteName => {
      this.cols.push({ field: siteName, header: `Added to ${siteName}`, type: 'tick-or-text' });
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }
}
